/*
*
*/

import util from '@/util'
import ConfirmDeletePromptMixin from "@/components/Mixins/Prompts/ConfirmDeletePrompt"

export default {
  mixins: [ ConfirmDeletePromptMixin ],

  // INFO: Component must define goalId !

  data: () => ({
    goal_is_deleting: false
  }),
  computed: {
    goal_categories() {
      let categories = this.$models.userGoalCategory.subscribeList().itemsSorted;
      categories.push({ $id: null, $key: 'unassigned', name: 'No category' })
      return categories;
    },

    user_goal_settings() {
      return this.$models.userGoalSettings.subscribeList();
    },

    goal_meta() {
      return this.$models.goalMeta.getNode( this.goalId );
    },

    /* TODO: Move to model getter? */
    goal_meta_map() {
      /* The reason why we create a (cached) map here, is that currently goals
         can not be loaded as list, which would require a method 'goal_meta(id)',
         to get goal meta data, but methods are not cached. */
      let goal_meta_map = {}
      for ( var goalSettingsId in this.user_goal_settings.items ) {
        if ( !goalSettingsId ) {
          continue
        }
        let goalMeta = this.$models.goalMeta.getNode( goalSettingsId );
        /* goal_meta_map[ goalSettingsId ] = {
          isTeamgoal: goalMeta.isTeamgoal || false,
          deleted:    goalMeta.deleted || false
        } */
        goal_meta_map[ goalSettingsId ] = Object.assign({
          isTeamgoal: false,
          deleted:    false
        }, goalMeta)
      }
      return goal_meta_map
    },

    /* TODO: Move to model getter? */
    currentUserIsAdmin() {
      let userId = this.$models.user.defaultUserId;
      let members = this.goal_meta.members;
      if ( userId in members && members[userId] ) {
        return members[userId].isAdmin;
      }
      return false;
    },

    /* TODO: Move to model getter? */
    currentUserIsOwner() {
      let userId = this.$models.user.defaultUserId;
      let members = this.goal_meta.members;
      if ( userId in members && members[userId] ) {
        return members[userId].isOwner;
      }
      return false;
    },
  },
  methods: {
    getUserGoalByCategoryId( categoryId ) {
      const goal_map  = this.goal_meta_map
      const goal_list = this.user_goal_settings
        .itemsAsArray()
        .filter( item => !goal_map[ item.$id ].deleted &&
                         ( item.categoryId || null ) === categoryId )
        .sort( util.sorter.by_sortidx );

      return goal_list
    },

    onAddGoal( categoryId, isTeamgoal = false ) {
      // TODO: this.$api.create_new_goal();
      // TODO: Team goal raus, categoryId rein
      this.$root.showNewModal('goal', { categoryId, isTeamgoal });
    },

    onUpdateGoalName( name ) {
      this.$api.goal_update_name({
        goal_id: this.goalId,
        name: name
      });

      // TODO: Also update for other users -> CF !? alternative remove cachedName
    },

    onLeaveGoal() {
      // TODO: Does not work
      // TODO: This will delete task meta !!!
      console.log("onLeaveGoal", this.goalId);
      this.$api.user_leave_goal({
        goal_id: this.goalId,
        goal_exist: true
      });
    },

    onDeleteGoal( soft_delete ) {

      // Check if user is allowed to delete (Currently only the owner is allowed)
      if ( !this.currentUserIsOwner ) {
        return this.$alert("Only the owner of the goal can delete it. You're not the owner of this goal. Please contact the owner and has him/her to remove it.", 'Info', {
          confirmButtonText: 'OK',
          callback: action => {
          }
        });
      }

      if ( soft_delete ) {
        return this.$api.goal_delete({
          goal_id: this.goalId,
          hard_delete: false
        })
      }

      let options = {
        title: this.goal_meta.name,
        askForConfirmation: true,
        additionalText: 'This will also delete ALL tasks and tasklists, commitments, recorded sessions and attachments. ',
      };
      this.$confirm_delete_prompt('goal', options).then(({ notify }) => {
        this.goal_is_deleting = true;
        this.$api.goal_delete({
          goal_id: this.goalId,
          hard_delete: true
        }).then(() => {
          this.goal_is_deleting = false;
          notify();
        })
      }).catch(e => e)
    },

    onInviteUser() { // TODO: mixin fehlt
      this.$invite_prompt_goal({
        goalId: this.goal.$id,
        cachedName: this.goal_meta.name,
        cachedPicture: this.goal_meta.picture
      })

      /*
      this.$user_prompt().then(({ selection, done }) => {
        this.$api.invite_to_goal_by_userid({
          goal_id: this.goal.$id,
          user_id: selection.id,
          user_pic: selection.profilePic, // TODO: This should be my user profile pic
          user_name: selection.displayName
        }).then(result => {
          if ( result.message ) {
            this.$message( result.message )
          }
          done();
        })
      })
      */
    },

    onRestoreGoal() {
      this.$api.goal_update({
        goal_id: this.goal.$id,
        data: { deleted: false }
      });
    },

    onGoToGoalSettings() {
      this.$router.push('/goal/' + this.goalId + '/settings')
    },

    onConvertGoal( isTeamgoal ) {
      this.$models.goalMeta.update( this.goalId, { isTeamgoal });
    },
  },
}
